import { useCallback, useEffect, useState } from 'react';

import { AccountTab } from '..';
import routes from '../../../../routes';

import useTabs, { PROFILE } from './useTabs';

const { Router } = routes;

const useMyAccountTabsManager = (currentTab?: AccountTab) => {
  const { tabsMap } = useTabs();
  const defaultTab = (currentTab && tabsMap[currentTab]) || PROFILE;
  const [tab, setTab] = useState(defaultTab);

  useEffect(() => {
    setTab(defaultTab);
  }, [defaultTab]);

  const pushRoute = (tab: AccountTab) => Router.pushRoute('account-tab', { tab }, { shallow: true });

  const handleTabChange = useCallback((tabIndex: number) => {
    const tab = Object.keys(tabsMap)[tabIndex] as AccountTab;
    setTab(tabsMap[tab]);
    pushRoute(tab);
  }, []);

  useEffect(() => {
    currentTab && !Object.keys(tabsMap).includes(currentTab) && pushRoute('profile');
  }, [currentTab]);

  return [tab, handleTabChange] as const;
};

export default useMyAccountTabsManager;
